module.exports = __webpack_public_path__ + "static/img/GH.a26e282e.svg";